import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { Authority } from '@/api'

@Module({
  name: 'AuthorityStore',
  namespaced: true,
  stateFactory: true
})
export default class AuthorityStore extends BaseStore {
  _authorityType: string = ''

  _searchResults: Authority[] = []

  _isCreateAuthority: boolean = false

  get authorityType(): string {
    return this._authorityType
  }

  get searchResults(): Authority[] {
    return this._searchResults
  }

  get isCreateAuthority(): boolean {
    return this._isCreateAuthority
  }

  @Mutation
  public setAuthorityType(value: string) {
    this._authorityType = value
  }

  @Mutation
  public setSearchResults(array: Authority[]) {
    this._searchResults = array
  }

  @Mutation
  public setIsCreateAuthority(value: boolean) {
    this._isCreateAuthority = value
  }

  @Mutation
  public updateSearchResult(obj: { index: number; authority: Authority }) {
    this._searchResults[obj.index] = obj.authority
  }

  @Mutation
  public deleteSearchResult(index: number) {
    this._searchResults.splice(index, 1)
  }

  @Mutation
  public reset() {
    this._authorityType = ''
    this._searchResults = []
    this._isCreateAuthority = false
  }
}
